<mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" class="px-15" fxLayoutAlign="space-between center">
        <span class="title dialog-title">Dettagli acconti versati {{ cellIsProvvisoria ? 'provvisori' : '' }} </span>
        <button mat-icon-button mat-dialog-close (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content class="p-24 m-0">
    <!-- Visualizzo questa schermata se la dichiarazione e' aperta oppure nel caso la dichiarazione e' provvisoria e si vogliono visualizzare i valori stimati
    (quindi si preme una cella della tabella non identificata come cella provvisoria). -->
    <ng-template
        [ngIf]="
            dettagliLm45.statoDichiarazione === statoDichiarazioneTemplate.Aperta ||
            (!cellIsProvvisoria && !(dettagliLm45.statoDichiarazione === statoDichiarazioneTemplate.Chiusa))
        "
        [ngIfElse]="dichiarazioneProvvisoriaOChiusa">
        <div class="cssWidgetWrapper">
            <dx-data-grid
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                [filterRow]="true"
                [dataSource]="dettagliAccontiVersatiDichiarazioneAperta"
                [allowColumnReordering]="true"
                [showBorders]="true"
                height="300px"
                [wordWrapEnabled]="true"
                [loadPanel]="{ enabled: true }">
                <dxi-column dataField="descrizione"> </dxi-column>
                <dxi-column alignment="right" dataField="importo" cellTemplate="importoTemplate">
                    <div *dxTemplate="let importoAcreditoTemplate of 'importoTemplate'">
                        {{
                            importoAcreditoTemplate.data.importo.toLocaleString('it-IT', {
                                style: 'currency',
                                currency: 'EUR',
                                minimumFractionDigits: 2
                            })
                        }}
                    </div>
                </dxi-column>

                <dxo-summary>
                    <dxi-total-item column="importo" [customizeText]="totaleImportoFormat" summaryType="sum"> </dxi-total-item>
                </dxo-summary>
            </dx-data-grid>
        </div>
    </ng-template>

    <!-- Se invece la dichiarazione e' chiusa o si preme una cella provvisoria visualizzo questa schermata -->
    <ng-template #dichiarazioneProvvisoriaOChiusa>
        <contributi-pagati-tramite-F24
            [dataToSendDichiarazione]="dettagliLm45.dataToSendDichiarazione"
            [categorieTributi]="{ primaCategoria: 1, secondaCategoria: 2 }">
        </contributi-pagati-tramite-F24>
    </ng-template>
</mat-dialog-content>
